import {collection, limit, orderBy, query, where} from "firebase/firestore";
import {fire} from "../../fire";
import {obtenerColeccionQuery} from "../../Servicios/BD/obtenerColeccionQuery";

export const obtenerProximoEvento = async () => {

    let q = query(collection(fire, 'eventos'),
        where('fecha', '>=', new Date().getTime(),
            where('estado', '==', 'Publicado'),
            limit(1)
        ))

    let dox = await obtenerColeccionQuery(q)
    if (dox.res && dox.data[0]) {
        console.log('aui')
        return dox.data[0]

    } else {

        let qdes = query(collection(fire, 'eventos'),
            where('estado', '==', 'Publicado'),
            orderBy('fecha', 'desc'),
            limit(1)
        )



        let dox = await obtenerColeccionQuery(qdes)
        return dox.data[0]

    }


}